import { useEffect, useState, useMemo } from "react";
import agent from "../../app/api/agent";
import { Box, CircularProgress, Typography, Stack } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";

interface Props {
  url: string;
  gte: string;
  lte: string;
}

interface CoverageRow {
  path: string;
  method: string;
  count: number;
}

export default function ApiCoverageTable({ url, gte, lte }: Props) {
  const [data, setData] = useState<CoverageRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    agent.Analytics.getAPICoverage({ url, gte, lte })
      .then((response) => {
        setData(response);
      })
      .catch((error) => {
        console.error("Error loading API coverage data", error);
      })
      .finally(() => setLoading(false));
  }, [url, gte, lte]);

  const columns: GridColDef[] = [
    { field: "path", headerName: "Path", flex: 1 },
    { field: "method", headerName: "Method", width: 120 },
    {
      field: "count",
      headerName: "Requests",
      width: 150,
      renderCell: (params) =>
        params.value === 0 ? (
          <span style={{ color: "red", fontWeight: "bold" }}>Blind spot</span>
        ) : (
          params.value
        ),
    },
  ];

  const { total, covered, blind, coveragePercent } = useMemo(() => {
    const total = data.length;
    const covered = data.filter((row) => row.count > 0).length;
    const blind = total - covered;
    const coveragePercent = total > 0 ? Math.round((covered / total) * 100) : 0;
    return { total, covered, blind, coveragePercent };
  }, [data]);

  return (
    <>
      <Typography variant="h6" mb={1}>
        API Coverage
      </Typography>

    {loading ? (
       <></>
    ): (
       <Stack direction="row" spacing={4} mb={2}>
        <Typography>Total endpoints: <strong>{total}</strong></Typography>
        <Typography>Covered: <strong>{covered}</strong></Typography>
        <Typography>Blind spots: <strong style={{ color: "red" }}>{blind}</strong></Typography>
        <Typography>Coverage: <strong>{coveragePercent}%</strong></Typography>
      </Stack>
    )}

     

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ height: 700, width: "100%" }}
      >
        {loading ? (
          <><CircularProgress /><br></br><Typography>   This may take more time</Typography></>
        ) : (
          <DataGrid
            rows={data}
            columns={columns}
            getRowId={(row) => `${row.path}-${row.method}`}
            pageSize={20}
            rowsPerPageOptions={[10, 20, 50]}
            disableSelectionOnClick
            sx={{ borderRadius: "12px" }}
          />
        )}
      </Box>
    </>
  );
}